import { render, staticRenderFns } from "./TotalRegistration.vue?vue&type=template&id=044d1453&"
import script from "./TotalRegistration.vue?vue&type=script&lang=js&"
export * from "./TotalRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports